<template>
	<img src="@/assets/Simulation_icon.svg" />
</template>